var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from './api-model';
import * as moment from 'moment';
import { Picture } from './picture';
var Rule = /** @class */ (function (_super) {
    __extends(Rule, _super);
    function Rule(data) {
        var _this = this;
        if (data.validityStartDate && data.validityStartDate.value && moment(data.validityStartDate.value).toDate().getTime() > 0) {
            data.startDate = moment(data.validityStartDate.value).toDate();
        }
        if (data.validityEndDate && data.validityEndDate.value && moment(data.validityEndDate.value).toDate().getTime() > 0) {
            data.endDate = moment(data.validityEndDate.value).toDate();
        }
        if (data.lastUpdatedDate && data.lastUpdatedDate.value && moment(data.lastUpdatedDate.value).toDate().getTime() > 0) {
            data.lastUpdate = moment(data.lastUpdatedDate.value);
        }
        if (data.picture) {
            data.picture = new Picture(data.picture);
        }
        _this = _super.call(this, data) || this;
        _this.wysiwyg = '';
        if (data.supportKind && _this.applyTo.length === 0) {
            _this.applyTo.push(data.supportKind.value);
        }
        if (!_this.id) {
            _this.languages = [];
        }
        _this.linkedRules = [];
        _this.updatedByUser = data.updatedByUser === '' ? '' : 'Updated by ' + data.updatedByUser;
        return _this;
    }
    Rule.prototype.setDates = function () {
        this.validityStartDate = {
            value: this.startDate
        };
        this.validityEndDate = {
            value: this.endDate
        };
    };
    return Rule;
}(ApiModel));
export { Rule };



// WEBPACK FOOTER //
// ./src/app/models/rule.ts.pre-build-optimizer.js